import type { ChromeLocale } from "@/lib/chrome-locale";

/**
 * Interactive-chrome strings (skip link, theme switch, account control) per
 * page language. These pieces live only on the React projection of the header
 * (INTERACTIVE_ONLY_CHROME), so they are not in the site-chrome model the edge
 * shell is generated from. Hindi UI text is Devanagari, never Roman Hinglish
 * (owner rule 2026-10-28, aad0f95aa8).
 */
export interface ChromeUiCopy {
  skipToContent: string;
  switchToDark: string;
  switchToLight: string;
  signIn: string;
  signOut: string;
  myJyotishi: string;
  myReading: string;
  myReadings: string;
  continueLatestReading: string;
  allVerifiedReadings: string;
}

export const CHROME_UI_COPY: Record<ChromeLocale, ChromeUiCopy> = {
  en: {
    skipToContent: "Skip to content",
    switchToDark: "Switch to dark theme",
    switchToLight: "Switch to light theme",
    signIn: "Sign in",
    signOut: "Sign out",
    myJyotishi: "My Jyotishi",
    myReading: "My Reading",
    myReadings: "My readings",
    continueLatestReading: "Continue latest reading",
    allVerifiedReadings: "All verified readings",
  },
  hi: {
    skipToContent: "मुख्य सामग्री पर जाएँ",
    switchToDark: "डार्क थीम चालू करें",
    switchToLight: "लाइट थीम चालू करें",
    signIn: "साइन इन करें",
    signOut: "साइन आउट करें",
    myJyotishi: "मेरा ज्योतिषी",
    myReading: "मेरी रीडिंग",
    myReadings: "मेरी रीडिंग्स",
    continueLatestReading: "पिछली रीडिंग जारी रखें",
    allVerifiedReadings: "सभी सत्यापित रीडिंग्स",
  },
};
